<template>
  <div>
    <div class="top_div" id="brand">
      <img class="home_banner" :src="bgImg" />
      <div class="div_top_title">
        <p>走&emsp;进&emsp;集&emsp;壹&emsp;实&emsp;业</p>
        <p class="litter_line_top"></p>
        <p class="p_title_sub">
          质&ensp;量&ensp;求&ensp;生&ensp;存 ·
          诚&ensp;信&ensp;求&ensp;发&ensp;展
        </p>
      </div>
    </div>

    <div class="simple_div_1">
      <img :src="CompanyList[0].img" />
      <!-- <img src="../../static/img/View_11.png" /> -->
      <div class="simple_1_bg">
        <div class="flex_container">
          <p class="p_title_1">{{ CompanyList[0].title }}</p>
          <p class="p_title_2">{{ CompanyList[0].titleNum }}</p>
        </div>
        <div class="litter_line_short"></div>
        <p class="p_content">
          {{ CompanyList[0].contentOne }}
        </p>
        <p class="p_content">
          {{ CompanyList[0].contentTwo }}
        </p>
        <p class="p_content">
          {{ CompanyList[0].contentThree }}
        </p>
      </div>
    </div>
    <div class="simple_father" id="brand_info">
      <div class="simple_div_2">
        <div class="trapezium_blue"></div>
        <div class="simple_flex_container">
          <img
            data-aos="fade-right"
            class="simple_img"
            :src="SimpleList[0].img"
          />
          <div data-aos="fade-left" class="simple_content">
            <p class="simple_div2_title">{{ SimpleList[0].title }}</p>
            <p class="litter_line_simple_white"></p>
            <p class="simple_div2_con">
              {{ SimpleList[0].contentOne }}
            </p>
            <!-- <p class="simple_div2_con">
              {{ SimpleList[0].contentTwo }}
            </p> -->
          </div>
        </div>
      </div>
      <div class="simple_div_3">
        <div class="trapezium_white"></div>
        <div class="simple_flex_container_right">
          <div data-aos="fade-right" class="simple_content_right">
            <p class="simple_div3_title">{{ SimpleList[1].title }}</p>
            <p class="litter_line_simple_black"></p>
            <p class="simple_div3_con">
              {{ SimpleList[1].contentOne }}
            </p>
            <!-- <p class="simple_div3_con">
              {{ SimpleList[1].contentTwo }}
            </p> -->
          </div>
          <img
            data-aos="fade-left"
            class="simple_img"
            :src="SimpleList[1].img"
          />
        </div>
      </div>
      <div class="simple_div_2">
        <div class="trapezium_blue"></div>
        <div class="simple_flex_container">
          <img
            data-aos="fade-right"
            class="simple_img"
            :src="SimpleList[2].img"
          />
          <div data-aos="fade-left" class="simple_content">
            <p class="simple_div2_title">{{ SimpleList[2].title }}</p>
            <p class="litter_line_simple_white"></p>
            <p class="simple_div2_con">
              {{ SimpleList[2].contentOne }}
            </p>
            <!-- <p class="simple_div2_con">
              {{ SimpleList[2].contentTwo }}
            </p> -->
          </div>
        </div>
      </div>
      <div class="simple_div_3">
        <div class="trapezium_white"></div>
        <div class="simple_flex_container_right">
          <div data-aos="fade-right" class="simple_content_right">
            <p class="simple_div3_title">{{ SimpleList[3].title }}</p>
            <p class="litter_line_simple_black"></p>
            <p class="simple_div3_con">
              {{ SimpleList[3].contentOne }}
            </p>
            <!-- <p class="simple_div3_con">
              {{ SimpleList[3].contentTwo }}
            </p> -->
          </div>
          <img
            data-aos="fade-left"
            class="simple_img"
            :src="SimpleList[3].img"
          />
        </div>
      </div>

      <div class="simple_banner" id="honor">
        <p class="title">QUALIFICATIONS</p>
        <p class="subtitle">荣&emsp;誉&emsp;资&emsp;质</p>

        <div class="swiper_father">
          <div class="swiper-container mySwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in BannerList"
                :key="index"
              >
                <div class="swiper_item">
                  <img :src="item.img" />
                  <div class="swiper_hover">
                    <!-- <img src="../../static/img/品牌页渐变.png"/> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper_btn_div">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
        <div class="swiper_father_phone">
          <div class="swiper-container mySwiperPhone">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide swiper-slide-phone"
                v-for="(item, index) in BannerList"
                :key="index"
              >
                <!-- <div class="swiper_item_phone"> -->
                <img :src="item.img" />
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: "",
      path: "brand",
      CompanyList: [
        {
          contentOne: "",
          contentThree: "",
          contentTwo: "",
          img: "",
          title: "",
          titleNum: "",
        },
      ],
      SimpleList: [
        {
          title: "",
          contentOne: "",
          contentTwo: "",
          img: "",
        },
        {
          title: "",
          contentOne: "",
          contentTwo: "",
          img: "",
        },
        {
          title: "",
          contentOne: "",
          contentTwo: "",
          img: "",
        },
        {
          title: "",
          contentOne: "",
          contentTwo: "",
          img: "",
        },
      ],
      BannerList: [
        {
          img: "",
          title: "",
        },
      ],
    };
  },
  created() {},
  components: {},
  mounted() {
    this.Init();
    var param = this.$route.query.param;
    this.path = param;
    console.log("param:" + param);
    this.navtoPartPath(this.path);
    // window.onresize = function () {
    //   if (window.innerWidth < 1000) {
    //     console.log('innerwidth'+window.innerWidth)
    //   }
    // };
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      var param = this.$route.query.param;
      this.path = param;
      console.log("param:" + param);
      this.navtoPartPath(this.path);
    },
    BannerList() {
      this.$nextTick(() => {
        var swiper = new Swiper(".mySwiper", {
          spaceBetween: 0,
          slidesPerView: 5,
          freeMode: true,
          // watchSlidesVisibility: true,
          // watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        var swiper2 = new Swiper(".mySwiperPhone", {
          slidesPerView: 3,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
          autoplay: true,
        });
      });
    },
  },
  methods: {
    Init() {
      this.getBgImg();
      this.getCompany();
      this.getSimple();
      this.getBanner();
    },
    navtoPartPath(path) {
      setTimeout(() => {
        document.getElementById(path).scrollIntoView();
      }, 500);
    },
    getBgImg() {
      let that = this;
      this.$axios
        .get("app/pagerimg/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.bgImg = response.data.page.list[0].img;
            // console.log(that.bgImg);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getCompany() {
      let that = this;
      this.$axios
        .get("app/brandcompany/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.CompanyList = response.data.page.list;
            console.log(that.CompanyList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getSimple() {
      let that = this;
      this.$axios
        .get("app/brandsimple/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.SimpleList = response.data.page.list;
            console.log(that.SimpleList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getBanner() {
      let that = this;
      this.$axios
        .get("app/brandbanner/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.BannerList = response.data.page.list;
            // console.log(that.BannerList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.top_div {
  height: 110rem;
  position: relative;
}

.home_banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #ec8938;

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: -20%;
  color: white;
  font-size: 4.8rem;
  line-height: 4.8rem;
  font-family: light;
  text-shadow: 4px 5px 6px rgba(0, 0, 0, 0.4);

  .p_title_sub {
    font-family: light;
    font-size: 1.8rem;
    line-height: 1.8rem;
    text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.4);
  }

  .litter_line_top {
    margin: 3rem auto;
    background-color: var(--textWhiteColor40);
    box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.4);
    height: 1px;
    width: 6%;
  }
}

.simple_div_1 {
  position: relative;
    height: 56rem;

  img {
    height: 100%;
    object-fit :cover;
    object-position: top;
    width: 100%;
  }

  .simple_1_bg {
    width: 40%;
    background-color: #00214099;
    position: absolute;
    top: 0;
    left: 5%;
    height: 100%;
    padding: 2rem;
  }

  .litter_line_short {
    margin-top: -1rem;
    margin-bottom: 10rem;
    background-color: var(--textWhiteColor);
    height: 2px;
    width: 3rem;
  }

  .p_title_1 {
    font-size: 3.6rem;
    color: var(--textWhiteColor);
    font-family: cjk_light;
  }

  .p_title_2 {
    font-size: 7.2rem;
    color: var(--textWhiteColor);
    font-family: didot_italic;
  }

  .p_content {
    margin-top: 2rem;
    font-size: 1.6rem;
    color: var(--textWhiteColor);
    font-family: light;
    text-align: left;
  }
}

.flex_container {
  display: flex;
  align-items: baseline;
  align-content: center;
}

.simple_father {
  background-color: #02203A;
  padding-top: 8rem;
  padding-bottom: 8rem;
}

.simple_div_2 {
  margin-top: 5rem;
  margin-bottom: 5rem;
  position: relative;
  background-color: var(--textBlueColor);
}

.simple_div_3 {
  margin-top: 5rem;
  margin-bottom: 5rem;
  position: relative;
  background-color: #02203A;
}

.simple_img {
  width: 82.3rem;
  height: 40rem;
  margin-left: 5rem;
}

.simple_flex_container {
  padding-top: 5rem;
  padding-bottom: 5rem;
  width: 75%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10rem;
  display: flex;
  align-items: center;
  align-content: center;
}

.simple_flex_container_right {
  padding-top: 5rem;
  padding-bottom: 5rem;
  width: 75%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10rem;
  display: flex;
  align-items: center;
  align-content: center;
}

.litter_line_simple_white {
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: var(--textWhiteColor);
  height: 1px;
  width: 100%;
}

.litter_line_simple_black {
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: black;
  height: 1px;
  width: 100%;
}

.simple_content {
  margin-left: 5rem;
}

.simple_content_right {
  margin-right: 5rem;
}

.simple_div2_title {
  color: var(--textWhiteColor);
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;
}

.simple_div2_con {
  color: var(--textWhiteColor);
  font-size: 1.8rem;
  font-family: light;
  text-align: left;
}

.simple_div3_title {
  color: black;
  font-size: 3.6rem;
  font-family: medium;
  text-align: right;
}

.simple_div3_con {
  color: black;
  font-size: 1.8rem;
  font-family: light;
  text-align: left;
}

.trapezium_blue {
  height: 0;
  width: 40%;
  border-bottom: 50rem solid #02203A;
  border-right: 20rem solid var(--textBlueColor);
}

.trapezium_white {
  height: 0;
  width: 80%;
  border-top: 50rem solid var(--textWhiteColor);
  border-right: 20rem solid #02203A;
}

.simple_banner {
  padding: 0 8rem;
  margin: 5rem 0;

  // background: var(--textBlueColor);
  .title {
    color: var(--textWhiteColor20);
    font-size: 10rem;
    font-family: bin_num_din;
  }

  .subtitle {
    margin-top: -6rem;
    margin-bottom: 5rem;
    color: var(--textWhiteColor);
    font-size: 4.8rem;
    font-family: medium;
  }
}

// .swiper-slide{
// width:43rem;
// height:60rem;
// }
.swiper_item {
  // width: 100%;
  // height:100%;
  position: relative;
  transition: all 0.6s ease 0s;
  // -webkit-mask-image:linear-gradient(to left, #00000000 ,#000000CC );
  // img{
  // width:100%;
  // height:100%;
  // }
}

.swiper_item:hover .swiper_hover {
  opacity: 0;
  transition: opacity;
  // filter: alpha(opacity=0);
  // background: null;
  // background: -webkit-linear-gradient(to right, #00000000, #00000000); /* Safari 5.1 - 6.0 */
  // background: -o-linear-gradient(to right, #00000000, #00000000); /* Opera 11.1 - 12.0 */
  // background: -moz-linear-gradient(to right, #00000000, #00000000); /* Firefox 3.6 - 15 */
  // background: linear-gradient(to right, #00000000, #00000000); /* 标准的语法（必须放在最后） */
}

.swiper_item:hover {
  transform: translateX(-30%);
  transition: all 0.6s ease 0s;
}

.swiper_hover {
  transition: opacity 2s ease-in-out;
  // transition: all 2s ease 0s;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: -webkit-linear-gradient(to right, #00000000, #00000000, #00000000, #00000000, #00000066); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to right, #00000000, #00000000, #00000000, #00000000, #00000066); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to right, #00000000, #00000000, #00000000, #00000000, #00000066); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #00000000, #00000000, #00000000, #00000000, #00000066); /* 标准的语法（必须放在最后） */
}

.mySwiper {
  height: 90%;
}

.swiper_father {
  margin: auto;
  position: relative;
  width: 90%;
  height: 70rem;
}

.swiper_btn_div {
  margin-top: 1rem;
  height: 5rem;
  display: flex;
  justify-content: space-between;
}

.swiper-button-next {
  padding: 1rem;
  position: relative;
  background: var(--textWhiteColor40);
  color: white;
  height: 5rem;
  width: 12rem;
  // top: 90%;
}

.swiper-button-prev {
  position: relative;
  background: var(--textWhiteColor40);
  color: white;
  height: 5rem;
  width: 12rem;
  // top: 90%;
}

.swiper-button-disabled {
  pointer-events: auto;
  opacity: 0.5;
}

.swiper-button-prev:hover {
  opacity: 1;
  background: var(--textBlueColor) !important;
}

.swiper-button-next:hover {
  opacity: 1;
  background: var(--textBlueColor) !important;
}

.swiper-button-prev:after {
  font-size: 3rem;
}

.swiper-button-next:after {
  font-size: 3rem;
}

.swiper_father_phone {
  display: none;
}

.swiper-slide-phone {
  width: 30%;
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);

  img {
    width: 33vw;
    // height: 25rem;
  }
}

.swiper-slide-active, .swiper-slide-duplicate-active {
  transform: scale(1);
}

@media screen and (max-width: 1200px) {
  .top_div {
    height: 90vh;
  }

  .home_banner {
    object-fit: cover;
  }

  .div_top_title {
    top: -30%;
    font-size: 3rem;

    .litter_line_top {
      width: 20%;
    }
  }

  .simple_div_1 {
    height: 75rem;

    img {
      object-fit: cover;
      object-position:90%;
      // height: 100%;
      // width: 100%;
    }

    .p_title_1 {
      font-size: 3rem;
    }

    .p_title_2 {
      font-size: 5rem;
    }

    .p_content {
      font-size: 1.6rem;
      line-height: 2.2rem;
    }

    .litter_line_short {
      width: 3rem;
      margin-bottom: 3rem;
    }

    .simple_1_bg {
      width: 90%;
      height: auto;
      top: auto;
      left: 0;
      right: 0;
      bottom: 5%;
      margin: 0 auto;
      padding: 0 2rem 5rem;
    }
  }

  .simple_div_2 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .simple_div_3 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .simple_flex_container {
    width: 100%;
    left: 0;
    padding-left: 2rem;
    padding-right: 1rem;
  }

  .simple_flex_container_right {
    width: 100%;
    left: 0;
    padding-left: 2rem;
    padding-right: 1rem;
  }

  .simple_content {
    margin-left: 2rem;
  }

  .simple_content_right {
    margin-right: 2rem;
  }

  .simple_div2_title {
    font-size: 2rem;
  }

  .simple_div2_con {
    font-size: 1.6rem;
  }

  .simple_div3_title {
    font-size: 2rem;
  }

  .simple_div3_con {
    font-size: 1.6rem;
  }

  .simple_father {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .trapezium_blue {
    width: 30%;
    border-bottom: 20rem solid #02203a;
    border-right: 10rem solid var(--textBlueColor);
  }

  .trapezium_white {
    width: 90%;
    border-top: 20rem solid var(--textWhiteColor);
  }

  .simple_img {
    width: 45vw;
    height: 16rem;
    object-fit: cover;
    margin-left: 0;
  }

  .simple_banner {
    padding: 0 2rem;
    margin-bottom: 2rem;

    .title {
      font-size: 5rem;
    }

    .subtitle {
      margin-top: -4rem;
      margin-bottom: 2rem;
      font-size: 3rem;
    }
  }

  .swiper_father {
    display: none;
  }

  .swiper_father_phone {
    display: block;
  }
}

@media screen and (min-width: 2200px) {
  .swiper_father {
    height: 90rem;
    width: 90%;
    margin: auto;
  }

  .swiper_item:hover {
    transform: translateX(-20%);
    transition: all 0.6s ease 0s;
  }

  .swiper_item {
    height: 100%;

    img {
      height: 100%;
    }
  }
}
</style>
